import React from "react";
import funnel from "../../images/funnel.svg";
const StudentBookContent = ({
  book,
  subTab,
  renderChapters,
  renderNewActivities,
  mode,
  setIsBookExpanded,
}) => {
  return (
    <div className="Contents_tabs">
      <div
        className="tabs_content classroom_wrap"
        id="myContents"
        style={{ padding: "0px" }}
      >
        <div
          className="Contents_Wrap_create accordion_Wrap"
          style={{ paddingLeft: mode === "studentFocusedMode" ? "24px" : "" }}
        >
          <h1
            className="f-16 mini_title"
            style={{ color: "var(--Black, #000)", marginBottom: "10px" }}
          >
            {book?.name || " "}
          </h1>
        </div>
        {subTab === "all" && (
          <div
            className="tab-pane fade show active custom_tabs_chapater"
            aria-labelledby="all-tab"
          >
            {renderChapters()}
          </div>
        )}
        {subTab === "activities" && (
          <div
            className="tab-pane fade show active"
            aria-labelledby="Activities-tab"
          >
            {renderNewActivities()}
          </div>
        )}
        {subTab === "activities-chapters" && (
          <div>
            <div className="sidebar_subheading">
              <span>CHAPTERS</span>
              <img src={funnel} alt="" />
            </div>
            <hr />
            <div className="vh-50">{renderChapters()}</div>
            <div className="sidebar_subheading">
              <span>ACTIVITIES</span>
              <img src={funnel} alt="" />
            </div>
            <hr />
            <div className="vh-50">{renderNewActivities()}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StudentBookContent;
